import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "helper/utils";
import { fetchCityInfo } from "services/common/osm";
import { getPlacesByText, getPlacesByTextV5 } from "services/web/mapbox.service";
import { CitiesFilter, PlaceFilter } from "types";

export const usePlacesQueryV5 = (filter: PlaceFilter) => {
  return useQuery({
    queryKey: ["search-places-v5", filter],
    queryFn: () => {
      return getPlacesByTextV5(filter);
    },
    enabled: !isEmpty(filter.keyWord),
  });
};

export const usePlacesQuery = (filter: PlaceFilter) => {
  return useQuery({
    queryKey: ["searchPlaces", filter],
    queryFn: () => {
      return getPlacesByText(filter);
    },
    enabled: !isEmpty(filter.keyWord),
  });
};

export const useCityQuery = (filter: CitiesFilter) => {
  return useQuery({
    queryKey: ["search-city-on-map", filter],
    queryFn: () => {
      return fetchCityInfo(filter);
    },
    enabled: !isEmpty(filter.name),
  });
};
